import styled from "styled-components";

const Select = styled.select`
  appearance: none;
  border: 1px solid #e6e6e6;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/bitterliebe-cms.appspot.com/o/chevron.png?alt=media&token=db8be432-c847-4a94-9899-ae1b230e05a0");
  background-repeat: no-repeat;
  background-position-x: calc(100% - .75rem);
  background-position-y: 50%;
  background-size: 24px;
  border-radius: 12px;
  padding: .75rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: .1s;
  &:hover {
    border: 1px solid #d2d2d2;
  }
  &:focus {
    outline: none;
  }
`;

export default Select;